"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const react_1 = __importDefault(require("react"));
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const styles_scss_1 = __importDefault(require("../styles.scss"));
const BadgeCell = ({ value }) => (react_1.default.createElement("div", { className: styles_scss_1.default.cell },
    react_1.default.createElement(components_1.Badge, { variant: value ? 'primary' : 'secondary', label: value ? constants_1.default.manageAccounts.active : constants_1.default.manageAccounts.inactive })));
const CapitalizedCell = ({ value }) => (react_1.default.createElement("div", { className: styles_scss_1.default.cell }, lodash_1.capitalize(value)));
const LinkCell = ({ cell, value }) => {
    const { row } = cell;
    const rowUser = row === null || row === void 0 ? void 0 : row.original;
    return (react_1.default.createElement(components_1.Link, { className: styles_scss_1.default.linkCell, to: `${constants_1.Routes.ManageAccounts}/${rowUser === null || rowUser === void 0 ? void 0 : rowUser.id}` },
        react_1.default.createElement("div", { className: styles_scss_1.default.cell }, value)));
};
exports.default = {
    BadgeCell,
    CapitalizedCell,
    LinkCell,
};
